import angular from 'angular';

import PreventDefaultDirective, { selector } from './prevent-default.directive';

export default angular.module('common.directive.prevent-default', [])
    .directive(selector, PreventDefaultDirective);



// WEBPACK FOOTER //
// ./src/common/directive/prevent-default/index.js